import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { BaseModal } from 'src/app/shared/base-modal';
import { MedicalRequest } from 'src/app/_models/PSP/medical-requests.model';
import { Pharmacy } from 'src/app/_models/PSP/pharmacy.model';
import { MedicationRequestService } from 'src/app/_services/PSP/medication-request.service';
import { PharmaciesService } from 'src/app/_services/PSP/pharmacies.service';
import { PatientSubscription } from 'src/app/_models/patient.model';
import { PatientService } from 'src/app/_services/patient.service';

@Component({
  selector: 'app-nearest-pharmacy-modal',
  templateUrl: './nearest-pharmacy-modal.component.html',
  styleUrls: ['./nearest-pharmacy-modal.component.scss'],
})
export class NearestPharmacyModalComponent extends BaseModal implements OnInit {
  searchPharmacyStep = 1;
  request: MedicalRequest;
  pharmacyList: Pharmacy[] = [];
  selectedPharmacy;
  selectedSubscription: PatientSubscription;
  isInsulinProgram = false;
  constructor(
    private readonly medicalRequestService: MedicationRequestService,
    private readonly toastr: ToastrService,
    private readonly pharmacyService: PharmaciesService,
    protected modal: NgbActiveModal,
    private readonly medicationService: MedicationRequestService,
    private readonly patientService: PatientService,
  ) {
    super(modal);
  }

  ngOnInit(): void {
    this.selectedSubscription = this.patientService.selectedSubscription;
    this.isInsulinProgram = this.medicationService.isInsulinRequest(this.selectedSubscription?.program?.name);
    this.medicalRequestService
      .getSelectedRequest()
      .subscribe((request: any) => {
        this.request = request;

        if (!request?.patientAddressData?.area) {
          window.history.back();
          return;
        }

        this.pharmacyService
          .getPspPharmaciesByAreaId(this.request.patientAddressData.area.id, this.isInsulinProgram)
          .subscribe((res) => {
            this.pharmacyList = res?.data?.pharmacies;
          });
      });
  }

  searchPharmacy(searchString): void {
    if (searchString.length > 0 && this.request?.patientAddressData?.area) {
      this.pharmacyService
        .searchPspPharmacies(this.request.patientAddressData.area.id, searchString, this.isInsulinProgram)
        .subscribe((res) => {
          this.pharmacyList = res?.data?.pharmacies;
        });
    }
  }

  onSelectPharmacy(pharmacy): void {
    this.selectedPharmacy = pharmacy;
    this.searchPharmacyStep = 2;
  }

  copyToClipboard(str): void {
    navigator.clipboard.writeText(str);
    showNotification('default', 'Copied to clipboard', this.toastr);
  }

  confirmRouteToPharmacy(closeButton): void {
    if (!this.request?.id || !this.selectedPharmacy?.id) {
      showNotification('error', 'Missing required data', this.toastr);
      return;
    }

    const body = {
      requestId: this.request.id,
      pspPharmacyId: this.selectedPharmacy.id,
    };
    this.medicalRequestService.routeToPharmacy(body).subscribe((res) => {
      showNotification(
        'success',
        'Patient Request is now in progress',
        this.toastr
      );
      closeButton.click();
    });
  }
}
